import React from "react";
import styled from "styled-components";

const Banner = styled.div`
  width: 100%;
  height: 100vh;
  background: url("/img/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  color: #fff;
`;

const Container = styled.div`
  width: 1200px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`;

const BannerText = styled.div`
  width: 500px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Heading3 = styled.h3`
  font-size: 40px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Heading1 = styled.h1`
  font-size: 80px;
  line-height: 80px;
  font-weight: 900;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 48px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  font-weight: 400;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const BannerButton = styled.div`
  margin-top: 35px;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

const Button = styled.a`
  text-decoration: none;
  border: none;
  outline: none;
  color: #fff;
  font-weight: 700;
  border-radius: 30px;
  font-size: 12px;
  padding: 20px 40px;
  background-color: #ffac1b;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff971b;
  }
`;

const Header = () => {
  return (
    <Banner>
      <BannerContent>
        <Container>
          <BannerText>
            <Heading3>Cake Birthday Delivery</Heading3>
            <Heading1>RazqaCake</Heading1>
            <Description>
              Kue Ulang Tahun Custom-Made, Mewujudkan Imajinasi Terbaikmu dan
              Desain Kue Sesuai Pesananmu.
            </Description>
            <BannerButton>
              <Button href="" className="btn btn-smart">
                DELIVERY NOW
              </Button>
            </BannerButton>
          </BannerText>
        </Container>
      </BannerContent>
    </Banner>
  );
};

export default Header;
